module.exports = __webpack_public_path__ + "img/pseudopic.131704c8.webp";